import { inject, Injectable, InjectionToken } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, filter, mergeMap, take, timeout as timeoutPipe } from 'rxjs/operators';
import { JSON } from '~/app/core/JSON.interface';
import { MessageService } from '../services/message.service';
import { LayoutService } from '../services/store/layout.service';
import { AppTranslationService } from '../services/translation/app-translation.service';

export const APP_CONFIG_RESOLVER_TIMEOUT = new InjectionToken<number>('APP_CONFIG_RESOLVER_TIMEOUT');

@Injectable({
  providedIn: 'root',
})
export class AppConfigResolver implements Resolve<JSON> {
  public appTranslationService = inject(AppTranslationService);
  private layoutService = inject(LayoutService);
  private messageService = inject(MessageService);
  private timeout = inject<number>(APP_CONFIG_RESOLVER_TIMEOUT, { optional: true });

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<JSON> {
    if (this.appTranslationService.hasStoredLanguages()) {
      return this.appTranslationService.setAppTranslationUserPreferredLang();
    } else {
      return this.appTranslationService.hasLanguagesStored.pipe(
        filter((value) => value),
        take(1),
        mergeMap(() => this.appTranslationService.setAppTranslationUserPreferredLang()),
        timeoutPipe(this.timeout ?? 30_000),
        catchError(() => {
          this.layoutService.setLoadingLocked(false);
          this.messageService.showErrorDialog();
          return of('No data');
        }),
      );
    }
  }
}
